import CrmPropostaService from "@/services/CrmPropostaService";
import VendaService from "@/services/VendaService";
import store from "@/store"
import moment from "moment"
export const actions = {
  cadastrarCrmProposta: ({ commit, dispatch }) => {
    commit("setCrmProposta", {
      id: "",
      proximo_contato: moment().add(3, 'days').format("YYYY-MM-DD"),
      proposta: "",
    }),
      dispatch("setModalCadastroCrmProposta", true);
  },
  listarCrmPropostas: ({ commit }, data) => {
    commit("setOverlay", true);
    CrmPropostaService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setCrmPropostas", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  async visualizarCrmProposta({ commit, dispatch }, data) {
    dispatch("visualizarOrcamento", data.proposta_id)
    .then(res => {
      commit("setCrmProposta", { ...data });
      dispatch("setModalVisualizarCrmProposta", true);
    })
    // await VendaService.editar(data.venda_id)
    //   .then((res) => {
    //     commit("setVenda", res.data);
    //   })
    //   .catch((e) => console.log(e));
    // dispatch("setModalCadastroCrmProposta", true);
  },
  salvarCrmProposta: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    CrmPropostaService.salvar(data)
      .then((res) => {
        // commit('addCrmProposta', res.data)
        commit("setCrmProposta", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Registro cadastrado.");
        dispatch("listarCrmPropostas", {});
        dispatch("setModalCadastroCrmProposta", false);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarCrmProposta: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    CrmPropostaService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Registro atualizado.");
        dispatch("listarCrmPropostas", {});
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirCrmProposta: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirCrmProposta", false);
    dispatch("setModalCadastroCrmProposta", false);
    CrmPropostaService.excluir(data.id)
      .then((res) => {
        dispatch("setModalVisualizarCrmProposta", false);
        dispatch("listarCrmPropostas", {});
        commit("setOverlay", false);
        commit("snackbarError", "Registro excluído.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir Registro.");
      });
  },
  setModalCadastroCrmProposta: ({ commit }, status) => {
    commit("setModalCadastroCrmProposta", false);
    setTimeout(() => {
      commit("setModalCadastroCrmProposta", status);
    }, 100);
  },
  setModalVisualizarCrmProposta: ({ commit }, status) => {
    commit("setModalVisualizarCrmProposta", false);
    setTimeout(() => {
      commit("setModalVisualizarCrmProposta", status);
    }, 100);
  },
  setModalAtualizarTabelaCrmProposta: ({ commit }, status) => {
    commit("setModalAtualizarTabelaCrmProposta", false);
    setTimeout(() => {
      commit("setModalAtualizarTabelaCrmProposta", status);
    }, 100);
  },
  setModalExcluirCrmProposta: ({ commit }, status) => {
    commit("setModalExcluirCrmProposta", false);
    setTimeout(() => {
      commit("setModalExcluirCrmProposta", status);
    }, 100);
  },
  setModalFinalizarCrmProposta: ({ commit }, status) => {
    commit("setModalFinalizarCrmProposta", false);
    setTimeout(() => {
      commit("setModalFinalizarCrmProposta", status);
    }, 100);
  },
  finalizarCrmProposta: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    CrmPropostaService.finalizar(data)
    .then((res) => {
      dispatch('setModalFinalizarCrmProposta', false)
      commit('snackbarSuccess', 'Registro finalizada com sucesso.')
      commit('setCrmProposta', {...store.getters.getCrmProposta, status: 'FINALIZADO'})
      commit("setOverlay", false);
    }).catch((e) => {
      console.log(e);
      commit("setOverlay", false);
    });
  },
};

export default {};
